import { Location } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { UntilDestroy } from '@ngneat/until-destroy';
import { UserOverviewBaseComponent } from '~features/manage/user-management/user-overview-base/user-overview-base.component';
import { SidebarService } from '~core/components/sidebar/sidebar.service';
import { ClubListTranslationsService, CustomerStatusTranslationsService } from '~shared/translations';
import {
  ClubService,
  DefaultNotificationService,
  NavigationService,
  ScreenSizeService,
  StorageService,
  UserManagementService,
  UserService,
} from '~core/services';
import { SidebarOptions } from '~core/models';

/**
 * Component responsible for user administration.
 */
@UntilDestroy()
@Component({
  selector: 'app-user-overview-profile',
  templateUrl: './user-overview-profile.component.html',
  styleUrls: ['./user-overview-profile.component.scss'],
})
export class UserOverviewProfileComponent extends UserOverviewBaseComponent implements OnInit, OnDestroy {

  constructor(
    public notificationService: DefaultNotificationService,
    public navigationService: NavigationService,
    public userService: UserService,
    public userModalService: UserManagementService,
    public router: Router,
    public clubService: ClubService,
    public clubListTranslations: ClubListTranslationsService,
    public location: Location,
    public formBuilder: UntypedFormBuilder,
    public storage: StorageService,
    public route: ActivatedRoute,
    public customerStatusTranslations: CustomerStatusTranslationsService,
    public screenSizeService: ScreenSizeService,
    public sidebarService: SidebarService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    super(notificationService, navigationService, userService, userModalService, router, clubService, clubListTranslations, location,
      formBuilder, storage, route, customerStatusTranslations, locale);
    this.navigationService.setCurrentPage('userProfile');
    this.navigationService.setCurrentBreadcrumbs(['globalSettings', 'userProfile']);
    this.sidebarService.setSidebar(new SidebarOptions(true, true));
  }

}
